import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import CheckCircleIcon from '../../../../static/img/CheckCircle.png';

interface RejectBookingSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000;
    padding: 20px;
`;

const ModalContainer = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    width: 480px;
    max-width: 90vw;
    position: relative;
    padding: 40px 32px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    color: #6b7280;
    cursor: pointer;
    padding: 4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        color: #374151;
    }
`;

const SuccessIconContainer = styled.div`
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SuccessIcon = styled.img`
    width: 80px;
    height: 80px;
    object-fit: contain;
`;

const SuccessMessage = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #111827;
    text-align: center;
    margin-bottom: 32px;
    line-height: 1.4;
`;

const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;
    justify-content: center;
`;

const CloseButtonFooter = styled.button`
    padding: 12px 24px;
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    background-color: #E5E7EB;
    color: #374151;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    
    &::before {
        content: '×';
        font-size: 20px;
        line-height: 1;
    }
`;

export default function RejectBookingSuccessModal({
    isOpen,
    onClose
}: RejectBookingSuccessModalProps) {
    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const modalContent = (
        <ModalOverlay onClick={handleOverlayClick}>
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={onClose}>×</CloseButton>
                <SuccessIconContainer>
                    <SuccessIcon src={CheckCircleIcon} alt="Success" />
                </SuccessIconContainer>
                <SuccessMessage>
                    Bạn đã từ chối booking <br /> thành công
                </SuccessMessage>
                <ButtonContainer>
                    <CloseButtonFooter onClick={onClose}>
                        Đóng
                    </CloseButtonFooter>
                </ButtonContainer>
            </ModalContainer>
        </ModalOverlay>
    );

    return createPortal(modalContent, document.body);
}

